import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../images/logo.png";
import "./style.css";
import abimg2 from "../../images/sign.png";

const socials = [
  {
    id: 1,
    icon: "ti-facebook",
    link: "https://www.facebook.com/Juzoursyria",
  },

  {
    id: 3,
    icon: "ti-instagram",
    link: "https://www.instagram.com/juzour.syria",
  },
];

const Footer = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <footer className="tp-ne-footer" dir="rtl">
      <div className="tp-site-footer">
        <div className="tp-upper-footer">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                <div
                  style={{ textAlign: "right" }}
                  className="widget about-widget"
                >
                  <div className="logo widget-title">
                    <img src={Logo} alt="" />
                  </div>
                  <p>
                    مجتمعات جذور بيئٌة آمنٌة وحافزٌة وداعمٌة لجميع أفرادها لعيش
                    كريم جذوره العلم والعمل والتكافل المجتمعي{" "}
                  </p>
                  <ul>
                    {socials.map((social) => (
                      <li key={social.id}>
                        <div className="parallax-wrap">
                          <div className="parallax-element">
                            <Link onClick={ClickHandler} to={social.link}>
                              <i className={social.icon}></i>
                            </Link>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col col-lg-3 offset-lg-1 col-md-6 col-sm-12 col-12">
                <div className="widget market-widget tp-service-link-widget">
                  <div className="signature">
                    <img style={{ width: "150px" }} src={abimg2} alt="" />
                  </div>
                  <div className="contact-ft">
                    <ul>
                      <li>
                        <i className="fi flaticon-pin"></i>Syria - Damascus
                      </li>
                      <li>
                        <i className="fi flaticon-call"></i>+963933333333
                      </li>
                      <li>
                        <i className="fi flaticon-envelope"></i>
                        jadorgroup@gmail.com
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-lower-footer">
          <div className="container">
            <div className="row">
              <div className="col col-xs-12">
                <p className="copyright">
                  &copy; {new Date().getFullYear()} Juzour. All rights reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
